import DepartmentsTable from "./departments-table";

export default DepartmentsTable;
